import mitt from "mitt";

// If you don't have mitt installed, run:
// npm install mitt

type Events = {
  "map:zoom": number; // The zoom level
  "geopackage:layers-imported": void; // When GeoPackage layers are imported
};

export const eventBus = mitt<Events>();
